import type { RouteRecordRaw } from 'vue-router'
import { ROUTE_ROLES } from '@/utils/permissions'

const routes: RouteRecordRaw[] = [
  {
    path: '/ops/alerts',
    name: 'OpsAlerts',
    component: () => import('@/views/ops/alerts.vue'),
    meta: {
      title: '运维告警中心',
      permission: 'ops:alerts',
      roles: ROUTE_ROLES.opsAlert,
    },
  },
]

export default routes
